const KEY = 'ADMIN_ACCOUNT';

export { KEY };
